import { Chip, Pressable, Text } from '@ayble-health/dashboard-components';
import { Box, Flex } from '@chakra-ui/react';
import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import styled from '@emotion/styled';
import moment from 'moment';
import { ROW_GRID, ROW_PADDING_X } from './constants';

const Hoverable = styled('div')`
  height: 100%;
  border-radius: 4px;
  transition: background-color 150ms ease-in;

  &:hover {
    background-color: ${(p) => p.theme.colors.blueGray['100']};
    cursor: pointer;
  }
`;

// next_meeting comes in as a | delimited string with 4 values about
// the upcoming meeting: date | provider | coach | confirmed
export const parseNextMeeting = (next_meeting) => {
  if (next_meeting == null) return '';

  const nextMeetingDetails = next_meeting.split('|');
  const meetingDate = moment
    .utc(nextMeetingDetails[0])
    .local()
    .format('ddd, MMM D h:mm A');
  const meetingProvider = nextMeetingDetails[1]
    ? 'Coach ' + nextMeetingDetails[1]
    : nextMeetingDetails[2];
  const meetingConfirmed = nextMeetingDetails[3] === 't';
  return [meetingDate, meetingProvider, meetingConfirmed];
};

export const HealthCoachDashboardListItem = ({ user }) => {
  const { email, first_name, id, last_name, next_meeting, last_engaged } = user;

  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [meetingDate, meetingProvider, meetingConfirmed] =
    parseNextMeeting(next_meeting);

  return (
    <Hoverable>
      <Pressable
        w="100%"
        h="100%"
        onClick={() => navigate(`/user-details/${id}?${searchParams}`)}
      >
        <Box
          display="grid"
          gridTemplateColumns={ROW_GRID}
          alignItems="center"
          gap={4}
          px={ROW_PADDING_X}
          h="100%"
          borderBottom="1px solid"
          borderColor="cloud.200"
        >
          <Flex direction="column" justifyContent="center" minW={0}>
            <Text truncate fontWeight={600} fontSize="md">
              {first_name || '-'} {last_name || '-'}
            </Text>
            <Text truncate fontSize={'xs'}>
              {email}
            </Text>
          </Flex>

          <Flex direction="column" justifyContent="center" minW={0} gap={0}>
            {meetingDate && (
              <Flex alignItems="center" gap={2} minW={0}>
                <Text
                  flexShrink={0}
                  whiteSpace="nowrap"
                  fontSize="sm"
                  fontWeight={500}
                  color="evergreen"
                >
                  {meetingDate}
                </Text>
                <Chip
                  variant={meetingConfirmed ? 'aqua' : 'symptom'}
                  flexShrink={0}
                >
                  {meetingConfirmed ? 'Confirmed' : 'Unconfirmed'}
                </Chip>
              </Flex>
            )}
            {meetingProvider && (
              <Text
                my={0}
                fontSize="xs"
                fontWeight={600}
                color="muted.500"
                lineHeight="sm"
              >
                {meetingProvider}
              </Text>
            )}
          </Flex>

          <Flex direction="column" justifyContent="center" minW={0}>
            <Text>
              {/* moment.utc reads offset-less timestamps as UTC (not browser-local) before converting. */}
              {last_engaged
                ? moment.utc(last_engaged).local().format('YYYY-MM-DD')
                : '--'}
            </Text>
          </Flex>
        </Box>
      </Pressable>
    </Hoverable>
  );
};
